import { APPLICANT_ATTRIBUTIONS } from 'cpool-constants';
import { z } from 'zod';

import { regex_iso_date } from '../../../../utils/regex.utils';
import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#einkunft-aus-nebent%C3%A4tigkeit

	{
		"betragMonatlich": schemaBigDecimal,
		"beginnDerTaetigkeit": "YYYY-MM-DD",
		"gehoertZuAntragsteller": "ANTRAGSTELLER_1" | "ANTRAGSTELLER_2"
	}

*/
export const schemaEuropaceEinkunftAusNebentaetigkeit = z.object({
    beginnDerTaetigkeit: z.optional(z.string().regex(regex_iso_date)),
    betragMonatlich: z.optional(schemaBigDecimal),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(z.nativeEnum(APPLICANT_ATTRIBUTIONS)),
    id: z.string().min(1),
});

export type SchemaEuropaceEinkunftAusNebentaetigkeit = z.infer<typeof schemaEuropaceEinkunftAusNebentaetigkeit>;
